import { nanoid } from 'nanoid';
import { mattressProjectSchema } from '@/domain/mattress/schema';
import { migrateProject } from './migrations';
/** Serializa um projeto como JSON pronto para download. */
export function serializeProject(project) {
    const envelope = {
        app: 'colchao-pra-mim',
        exportedAt: new Date().toISOString(),
        exportVersion: 1,
        project,
    };
    return JSON.stringify(envelope, null, 2);
}
/**
 * Parseia e valida um JSON de projeto. Regenera o ID quando já existe na lib,
 * para nunca sobrescrever projetos do usuário silenciosamente.
 */
export function parseProjectImport(raw, existingIds) {
    let parsed;
    try {
        parsed = JSON.parse(raw);
    }
    catch {
        throw new Error('JSON inválido.');
    }
    // Aceita envelope "colchao-pra-mim" OU um MattressProject puro
    let candidate = parsed;
    if (parsed &&
        typeof parsed === 'object' &&
        'project' in parsed &&
        parsed.app === 'colchao-pra-mim') {
        candidate = parsed.project;
    }
    const migrated = migrateProject(candidate);
    const validated = mattressProjectSchema.parse(migrated);
    let idReassigned = false;
    let project = validated;
    if (existingIds.has(project.id)) {
        project = {
            ...project,
            id: nanoid(12),
            dataAtualizacao: new Date().toISOString(),
            nome: `${project.nome} (importado)`,
        };
        idReassigned = true;
    }
    return { project, idReassigned };
}
/** Dispara o download de um projeto como .json via <a> temporário. */
export function downloadProjectJson(project) {
    const json = serializeProject(project);
    const blob = new Blob([json], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    const safeName = project.nome.replace(/[^\p{L}\p{N}\-_ ]/gu, '').trim() || 'projeto';
    a.href = url;
    a.download = `${safeName}.colchaoprami.json`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}
